export default "__VITE_ASSET__iQ4X$bfn__"